<template>
  <div class="w-full">
    <NText variant="caption2" weight="regular" class="text-neutral-primary">
      {{ t('option.chainStatusDescription') }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
